import { createContext } from 'react';
import { ROUTE_QUIZ_INTRO } from '@hungryroot/routes';
import { DEFAULT_QUIZ_STORAGE_NAMESPACE } from './defs/localStorage';
import { defaultQuiz } from './defs/quiz';
import { type UseQuizResultWithQuiz } from './quiz-hooks';

const noop = () => void 0;

const quizContentDefaultValue: UseQuizResultWithQuiz<string> = {
  quiz: defaultQuiz,
  onQuestionAnswer: noop,
  onSubmit: noop,
  navigationState: {
    next: null,
    path: ROUTE_QUIZ_INTRO,
    prev: null,
  },
  onSaveAndExit: noop,
  onQuizInit: noop,
  quizToast: undefined,
  screens: [],
  sections: [],
  isMiniQuiz: false,
  storageNamespace: DEFAULT_QUIZ_STORAGE_NAMESPACE,
};

export const QuizContext = createContext<UseQuizResultWithQuiz<string>>(
  quizContentDefaultValue
);
